import React, { FC } from "react";

import { Button, TFilterWithData, ThemeProvider } from "../../../components";
import useFilter from "../useFilter";
import { mobileFilterItems } from "../../../mock/filtersMock";
import { renderFilter } from "../RenderFilterStrategy";

const MobileFilter: FC = () => {
  const {
    total,
    filterItemsState,
    handleClearAll,
    formSubmitHandler,
    handleFiltersChange,
  } = useFilter({ filterItems: mobileFilterItems as TFilterWithData[] });

  return (
    <ThemeProvider theme="dark">
      <form className="filter-mobile-wrapper" onSubmit={formSubmitHandler}>
        <div className="filter-mobile-body">
          {filterItemsState.map((filter: TFilterWithData) =>
            renderFilter({ filter, onFilterChange: handleFiltersChange }),
          )}
        </div>
        {total > 0 && (
          <div className="filter-mobile-footer">
            <Button type="submit" onClick={handleClearAll} variant="cancel">
              Clear All
            </Button>
            <Button type="submit" variant="submit" classes={{ root: "ms-6" }}>
              Show {total}
            </Button>
          </div>
        )}
      </form>
    </ThemeProvider>
  );
};

export default MobileFilter;
